var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0411\\u0435\\u043B\\u044B\\u0435",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 141.7 141.7",
    style: {
      enableBackground: "new 0 0 141.7 141.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M137.9,124.6h-14.6c-1.9,0-3.5-1.6-3.5-3.5s1.6-3.5,3.5-3.5h14.6c1.9,0,3.5,1.6,3.5,3.5S139.9,124.6,137.9,124.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.1,124.6h-79c-1.9,0-3.5-1.6-3.5-3.5s1.6-3.5,3.5-3.5h79c1.9,0,3.5,1.6,3.5,3.5S85.1,124.6,83.1,124.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.9,74H62.2c-1.9,0-3.5-1.6-3.5-3.5s1.6-3.5,3.5-3.5h75.7c1.9,0,3.5,1.6,3.5,3.5S139.9,74,137.9,74z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2,74H4.2c-1.9,0-3.5-1.6-3.5-3.5S2.2,67,4.2,67h18.1c1.9,0,3.5,1.6,3.5,3.5S24.2,74,22.2,74z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.9,24.8h-15.5c-1.9,0-3.5-1.6-3.5-3.5s1.6-3.5,3.5-3.5h15.5c1.9,0,3.5,1.6,3.5,3.5S139.9,24.8,137.9,24.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.1,24.8h-79c-1.9,0-3.5-1.6-3.5-3.5s1.6-3.5,3.5-3.5h79c1.9,0,3.5,1.6,3.5,3.5S85.1,24.8,83.1,24.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.7,43.2H90.4c-5.1,0-9.2-4.1-9.2-9.2V8.7c0-5.1,4.1-9.2,9.2-9.2h25.3c5.1,0,9.2,4.1,9.2,9.2V34 C124.8,39.1,120.7,43.2,115.7,43.2z M90.4,6.5c-1.2,0-2.2,1-2.2,2.2V34c0,1.2,1,2.2,2.2,2.2h25.3c1.2,0,2.2-1,2.2-2.2V8.7 c0-1.2-1-2.2-2.2-2.2H90.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.7,142.2H90.4c-5.1,0-9.2-4.1-9.2-9.2v-25.3c0-5.1,4.1-9.2,9.2-9.2h25.3c5.1,0,9.2,4.1,9.2,9.2v25.3 C124.8,138.1,120.7,142.2,115.7,142.2z M90.4,105.6c-1.2,0-2.2,1-2.2,2.2v25.3c0,1.2,1,2.2,2.2,2.2h25.3c1.2,0,2.2-1,2.2-2.2v-25.3 c0-1.2-1-2.2-2.2-2.2H90.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4,92.7H30.1c-5.1,0-9.2-4.1-9.2-9.2V58.2c0-5.1,4.1-9.2,9.2-9.2h25.3c5.1,0,9.2,4.1,9.2,9.2v25.3 C64.6,88.6,60.5,92.7,55.4,92.7z M30.1,56c-1.2,0-2.2,1-2.2,2.2v25.3c0,1.2,1,2.2,2.2,2.2h25.3c1.2,0,2.2-1,2.2-2.2V58.2 c0-1.2-1-2.2-2.2-2.2H30.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.ee68e82576cb9e50160864c5e360edcf.svg";
export { ForwardRef as ReactComponent };